import { ActionButton, Dropdown, IDropdownOption, IIconProps, Label, TextField } from '@fluentui/react';
import React, { useContext, useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useDebouncedCallback from 'use-debounce/lib/useDebouncedCallback';
import {
  GetVPFilterDropdownData,
  readMidTermPlanning,
  readVPPBSTaxonomyData,
  saveVPStateAttr,
} from '../../../reducers/visualPlanReducer';
import CustomDatePicker from '../../../shared/customDatePicker/customDatePicker';
import { ViewMode } from '../../../shared/ganttv2';
import {
  formatDateTimeToISOString,
  getSelectedFilterDates,
  updateVPProductStatusFilter,
  updateVPStandardFilter,
} from '../../../shared/util';
import { ViewModeContext } from './component';
import ModeSwitcherWithRadioButtons from '../../../shared/ganttViewSwitcher/viewSwitcherWithRadioButtons';
import CustomDropdown from '../../../shared/customDropdown/customDropdown';
import _ from 'lodash';

export const ViewSwitcher: React.FC = () => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  // const [isProjectSelected, setIsProjectSeleted] = React.useState<boolean>(true);
  const [searchTriggered, setSearchTriggered] = React.useState<boolean>(false);
  const [endDate, setEndDate] = React.useState<Date | null>(null);
  const [selectedMode, setSelectedViewMode] = React.useState<ViewMode>(ViewMode.QuaterYear);
  const [prodStatusFilterKey, setProdStatusFilterKey] = React.useState<any>('1');
  const [selectedProject, setSelectedProject] = React.useState<any>(null);
  const [standardFilterKey, setStandardFilterKey] = React.useState<any>('5'); // Initially set to Project
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onViewModeChange, onViewListChange, isCheck } =
    useContext(ViewModeContext);

  const standerdFilterOptions = useSelector(
    (state: any) => updateVPStandardFilter(state.vp.vpFilterDropdown),
  );

  const addFriendIcon: IIconProps = { iconName: 'Refresh' };


  const productStatusFilterOptions = useSelector(
    (state: any) => updateVPProductStatusFilter(state.projectBreakdown?.productStates),
  );

  const vpProjectListForFilter: any[] = useSelector(
    (state: any) => state.vp.vpProjectListForFilter,
  );

  // useEffect(() => {
  //   dispatch(GetVPFilterDropdownData());
  // }, []);

  const debounced = useDebouncedCallback(
    (value: any) => {
      if (value) {
        dispatch(
          readMidTermPlanning({
            fromDate: formatDateTimeToISOString(startDate!!),
            toDate: formatDateTimeToISOString(endDate!!),
            title: value,
            projectTitle: selectedProject,
          }),
        );
      } else {
        dispatch(
          readMidTermPlanning({
            fromDate: formatDateTimeToISOString(startDate!!),
            toDate: formatDateTimeToISOString(endDate!!),
            title: value,
            projectTitle: selectedProject,
          }),
        );
      }
    },
    // delay in ms
    1000,
  );

  const projectOptions = (inputValue: any) =>
    new Promise((resolve) => {
      resolve(getProjectByName(inputValue));
    });

  const getProjectByName = async (name: string) => {
    const response = vpProjectListForFilter.filter(
      (element: { text: string; value: string }) => element.text.toLowerCase().includes(name.toLowerCase()),
    );
    return formatProjectResponse(response).sort();
  };

  const formatProjectResponse = (response: any) => {
    if (response) {
      if (_.isArray(response)) {
        const titleNotEmptyList = response.filter(
          (item: { name: string | null }) => item.name !== null,
        );
        const data = titleNotEmptyList.map((item: any) => {
          return {
            value: item.key,
            label: item.text,
          };
        });
        return data;
      }
      return [];
    }
    return [];
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        height: 70,
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderBottom: '0.5px solid gray',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          flexGrow: 0.2,
          width: '100%',
        }}
      >
        <Form
          onSubmit={() => {
          }}
          initialValues={{
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
          }}
          mutators={{
            setHeaderDocs: (args, state, utils) => {
              const field = state.fields['header.files'];
              field.change(args[0]);
            },
            setDateRange: (args, state, utils) => {
              const from = state.fields['startDate'];
              const to = state.fields['endDate'];
              from.change(getSelectedFilterDates(args)[0]);
              to.change(getSelectedFilterDates(args)[1]);
              dispatch(
                saveVPStateAttr(
                  'scrollPosDate',
                  getSelectedFilterDates(args)[0],
                ),
              );

              dispatch(
                readMidTermPlanning({
                  fromDate: formatDateTimeToISOString(
                    getSelectedFilterDates(args)[0],
                  ),
                  toDate: formatDateTimeToISOString(
                    getSelectedFilterDates(args)[1],
                  ),
                  filter: args[0],
                  productStatus: prodStatusFilterKey == 1 ? null : prodStatusFilterKey,
                }),
              );
            },
          }}
          // validate={ validate }
          render={({
                     handleSubmit,
                     form,
                     // submitting,
                     // pristine,
                     values,
                   }) => {
            // props.submit(handleSubmit);

            return (
              <form onSubmit={handleSubmit} noValidate>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    height: 70,
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      height: 70,
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: 1,
                        height: 70,
                        width: '100%',
                      }}
                    >

                      <div style={{ width: 180, marginRight: 10 }}>
                        <div style={{ width: 180, marginLeft: 15 }} className={'projectSelect'}>
                          <Label style={{ width: 180 }}>{t('projectSearch')}</Label>
                          <Field name="project">
                            {({ input, meta }) => (
                              <CustomDropdown
                                reference={''}
                                onChange={(
                                  key: string,
                                  label: string,
                                ) => {
                                  let project = null;
                                  if (key) {
                                    input.onChange(key);
                                    project = label;
                                    setSelectedProject(label);
                                  } else {
                                    input.onChange(null);
                                    setSelectedProject(null);
                                  }
                                  dispatch(
                                    readMidTermPlanning({
                                      title: values.searchString,
                                      fromDate: values.date ? formatDateTimeToISOString(getSelectedFilterDates(values.date)[0]) : null,
                                      toDate: values.date ? formatDateTimeToISOString(getSelectedFilterDates(values.date)[1]) : null,
                                      projectTitle: project,
                                    }))
                                }}
                                selectedOption={
                                  values && values?.project ?
                                    {
                                      value: values?.project,
                                      // label: getProjectTitle(values?.project),
                                      label: values?.project,
                                    }
                                    : null
                                }
                                promiseOptions={projectOptions}
                                validationMessage={''}
                                required={true}
                              />
                            )}
                          </Field>
                        </div>
                      </div>

                      <div style={{ width: 180 }}>
                        <div style={{ width: 180, marginLeft: 15 }}>
                          <Label style={{ width: 180 }}>{t('pbsSearch')}</Label>
                          <Field name='searchString'>
                            {({ input }) => (
                              <TextField
                                value={values.searchString}
                                placeholder={t('search')}
                                onChange={(event, value) => {
                                  if (value?.length!! >= 1) {
                                    input.onChange(value);
                                  } else {
                                    input.onChange(null);
                                  }
                                  if (value?.length!! >= 3) {
                                    setSearchTriggered(true);
                                    debounced(value);
                                    //handleTreeOnSearch(value);
                                  } else if (value?.length!! === 0 && searchTriggered) {
                                    setSearchTriggered(false);
                                    debounced(null);
                                    //handleTreeOnSearch('');
                                  }
                                }}
                              />
                            )}
                          </Field>
                        </div>
                      </div>

                      <div style={{ width: 180, marginLeft: 20 }}>
                        <Field name='productStatus'>
                          {({ input }) => (
                            <Dropdown
                              placeholder={t('productStatus')}
                              label={t('productStatus')}
                              selectedKey={prodStatusFilterKey}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(
                                event: React.FormEvent<HTMLDivElement>,
                                item: IDropdownOption | undefined,
                              ) => {
                                if (item) {
                                  setProdStatusFilterKey(item.key);
                                  input.onChange(
                                    dispatch(
                                      readMidTermPlanning({
                                        title: values.searchString,
                                        fromDate: values.date ? formatDateTimeToISOString(getSelectedFilterDates(values.date)[0]) : null,
                                        toDate: values.date ? formatDateTimeToISOString(getSelectedFilterDates(values.date)[1]) : null,
                                        productStatus: item.key == 1 ? null : item.key,
                                      })),
                                  );
                                }
                              }}
                              options={productStatusFilterOptions}
                            />
                          )}
                        </Field>
                      </div>

                      <div style={{ width: 180, marginLeft: 15 }}>
                        <Field name='date'>
                          {({ input }) => (
                            <Dropdown
                              placeholder={t('standardFilter')}
                              label={t('standardFilter')}
                              selectedKey={standardFilterKey}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(event, value) => {
                                if (value) {
                                  input.onChange(value.key);
                                  setStandardFilterKey(value.key);
                                } else {
                                  input.onChange(null);
                                }
                                form.mutators.setDateRange(value?.key);
                                if (value?.key === '5') {
                                  onViewModeChange(ViewMode.QuaterYear);
                                  // setIsProjectSeleted(true)
                                  setSelectedViewMode(ViewMode.QuaterYear);
                                } else {
                                  onViewModeChange(ViewMode.Week);
                                  // setIsProjectSeleted(false)
                                  setSelectedViewMode(ViewMode.Week);
                                }
                              }}
                              options={
                                standerdFilterOptions
                                  ? standerdFilterOptions
                                  : []
                              }
                            />
                          )}
                        </Field>
                      </div>

                      <div
                        className={'vpDatePicker180'}
                        style={{ width: 180, marginLeft: 15 }}
                      >
                        <Label style={{ width: 180 }}>{t('fromDate')}:</Label>
                        <Field name='startDate'>
                          {({ input }) => (
                            <CustomDatePicker
                              setValue={values.startDate}
                              getValue={(date: Date) => {
                                setStandardFilterKey('8');
                                input.onChange(date);
                                setStartDate(date);
                                input.onChange(date);
                                const clDate = new Date(date);
                                const newDate = new Date(
                                  clDate.setDate(clDate.getDate() + 30),
                                );
                                setEndDate(newDate);

                                dispatch(
                                  readMidTermPlanning({
                                    fromDate: formatDateTimeToISOString(date),
                                    toDate: formatDateTimeToISOString(newDate),
                                    productStatus: prodStatusFilterKey == 1 ? null : prodStatusFilterKey,
                                  }),
                                );
                              }}
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        className={'vpDatePicker180'}
                        style={{ width: 180, marginLeft: 15 }}
                      >
                        <Label style={{ width: 180 }}>{t('toDate')}:</Label>
                        <Field name='endDate'>
                          {({ input }) => (
                            <CustomDatePicker
                              setMinDate={
                                startDate
                                  ? startDate
                                  : new Date(
                                    form.getFieldState('startDate')?.value,
                                  )
                              }
                              setValue={values.endDate}
                              getValue={(date: Date) => {
                                setStandardFilterKey('8');
                                input.onChange(date);
                                setEndDate(date);
                                dispatch(
                                  readMidTermPlanning({
                                    fromDate: formatDateTimeToISOString(startDate!!),
                                    toDate: formatDateTimeToISOString(date),
                                    productStatus: prodStatusFilterKey == 1 ? null : prodStatusFilterKey,
                                  }),
                                );
                              }}
                            />
                          )}
                        </Field>
                      </div>

                      <ModeSwitcherWithRadioButtons
                        onViewModeChange={(t: any) => {
                          onViewModeChange(t);
                          setSelectedViewMode(t);
                        }}
                        onViewListChange={onViewListChange}
                        isCheck={isCheck}
                        selectedViewMode={selectedMode}
                      />


                      <ActionButton onClick={() => {
                        dispatch(
                          readMidTermPlanning({
                            fromDate: formatDateTimeToISOString(startDate!!),
                            toDate: formatDateTimeToISOString(endDate!!),
                            productStatus: prodStatusFilterKey == 1 ? null : prodStatusFilterKey,
                          }),
                        );
                      }}
                                    iconProps={addFriendIcon}
                                    allowDisabledFocus
                                    disabled={false}
                                    checked={false}
                                    style={{ marginTop: 15 }}>
                        {t('refresh')}
                      </ActionButton>

                    </div>
                  </div>
                </div>

                 {/*<pre>{ JSON.stringify(values, null, 2) }</pre>*/}
              </form>
            );
          }}
        />
      </div>
    </div>
  );
};
